var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0762C14.1421 18.0762 17.5 14.7183 17.5 10.5762C17.5 6.43404 14.1421 3.07617 10 3.07617C5.85786 3.07617 2.5 6.43404 2.5 10.5762C2.5 14.7183 5.85786 18.0762 10 18.0762Z",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.5762C10.5178 15.5762 10.9375 15.1564 10.9375 14.6387C10.9375 14.1209 10.5178 13.7012 10 13.7012C9.48223 13.7012 9.0625 14.1209 9.0625 14.6387C9.0625 15.1564 9.48223 15.5762 10 15.5762Z",
    fill: "#969992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.8262V11.2012C10.4326 11.2012 10.8556 11.0729 11.2153 10.8325C11.575 10.5921 11.8554 10.2505 12.021 9.85079C12.1866 9.45108 12.2299 9.01125 12.1455 8.58691C12.0611 8.16258 11.8527 7.7728 11.5468 7.46688C11.2409 7.16095 10.8511 6.95261 10.4268 6.86821C10.0024 6.7838 9.56259 6.82712 9.16288 6.99269C8.76317 7.15825 8.42153 7.43863 8.18116 7.79836C7.94079 8.1581 7.8125 8.58103 7.8125 9.01367",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIco);
export default __webpack_public_path__ + "static/media/help_ico.8414a7cecf0d178623ed3d1eb41336bf.svg";
export { ForwardRef as ReactComponent };